// Wishlist.jsx
import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserWishlist, deleteWishlist } from "../redux/actions/wishlist";
import { FaTrash } from "react-icons/fa";
import helper from "../Custom/CustomHelpers";

function Wishlist() {
  const dispatch = useDispatch();
  const wishlistItems = useSelector(
    (state) => state.wishlist.wishlistProducts || []
  );

  const deleteItem = async (item) => {
    await dispatch(
      deleteWishlist({ productId: item.productId, userUID: item.userUID })
    );
    dispatch(getUserWishlist({ productId: 0, userUID: item.userUID }));
  };

  const getWishlistPrice = (product) => {
    const basePrice =
      product.priceType === 1
        ? product.prices.find((x) => x.sortOrder == 1)?.price
        : product.basePrice;
    if (!product?.offer || !product.offer.isActive) {
      return {
        hasDiscount: false,
        price: basePrice,
      };
    }

    // Quantity offers don't apply in wishlist
    if (product.offer.offerType === "Quantity") {
      return {
        hasDiscount: false,
        price: basePrice,
      };
    }

    // Percentage offer
    const discountPercent = product.offer.offerValue;
    const discountedPrice = basePrice - (basePrice * discountPercent) / 100;

    return {
      hasDiscount: true,
      originalPrice: basePrice,
      discountedPrice,
      discountPercent,
    };
  };

  return (
    <div className="fixed w-3/4 max-w-md p-4 border border-gray-500 rounded-lg shadow sm:p-8 right-2 top-24 bg-custom-white text-custom-dark dark:text-custom-white dark:bg-custom-dark overflow-y-auto h-4/6 z-[1000]">
      <div className="flex items-center justify-between mb-4">
        <h5 className="text-xl font-bold leading-none select-none">Wishlist</h5>
        <AiOutlineClose
          className="cursor-pointer"
          onClick={() => dispatch({ type: "WISHLIST_DRAWER", payload: false })}
        />
      </div>

      {wishlistItems.length === 0 && (
        <p className="text-gray-500 text-center">No items in wishlist</p>
      )}

      {wishlistItems.map((item, i) => (
        <div className="flow-root mb-4" key={i}>
          <ul className="divide-y divide-gray-200 dark:divide-gray-800">
            <li className="py-3 sm:py-4 flex items-start sm:items-center gap-4">
              {/* NavLink wraps image + title block */}
              <NavLink
                to={`/product/${helper.generateSlug(item.product)}`}
                className="flex flex-1 items-center gap-4"
                onClick={() =>
                  dispatch({ type: "WISHLIST_DRAWER", payload: false })
                }
              >
                <div className="flex-shrink-0">
                  <img
                    className="w-16 h-16 object-contain"
                    src={item?.product?.image}
                    alt={item?.product?.title}
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium break-words">
                    {item?.product?.title}
                  </p>
                  <div className="flex flex-col items-end">
                    {/* {cart.discountedPrice < cart.basePrice && (
                      <span className="text-sm text-red-500 line-through">
                        Rs. {cart.basePrice.toFixed(2)}
                      </span>
                    )} */}

                    {/* <span className="text-base font-semibold text-green-600">
                      Rs. {getCartItemPrice(cart).toFixed(2)}
                    </span> */}

                    {item?.product?.unitValue && (
                      <span className="text-xs text-gray-500">
                        {item?.product?.unitValue}{" "}
                        {helper.UNIT_TYPE_LABEL[item?.product?.unitType]}
                      </span>
                    )}
                  </div>

                  {(() => {
                    const price = getWishlistPrice(item.product);

                    return price.hasDiscount ? (
                      <div className="flex items-center gap-2">
                        <span className="text-red-500 line-through text-sm">
                          Rs. {price.originalPrice}
                        </span>
                        <span className="text-green-600 font-semibold text-sm">
                          Rs. {price.discountedPrice}
                        </span>
                        {item.product.offer?.isActive &&
                          item.product.offer.offerType === "Percentage" && (
                            <span className="text-xs text-green-600 font-semibold">
                              -{item.product.offer.offerValue}%
                            </span>
                          )}
                      </div>
                    ) : (
                      <p className="text-sm text-gray-400">Rs. {price.price}</p>
                    );
                  })()}
                </div>
              </NavLink>

              {/* Delete button */}
              <div className="flex flex-col items-end text-right">
                <button
                  aria-label="remove wishlist item"
                  className="text-red-500 underline text-sm"
                  onClick={() => deleteItem(item)}
                >
                  <FaTrash className="hover:text-red-700 cursor-pointer" />
                </button>
              </div>
            </li>
          </ul>
        </div>
      ))}

      {wishlistItems.length > 0 && (
        <div className="mt-4">
          <button
            aria-label="view all products"
            className="w-full bg-custom-green text-custom-dark rounded-md py-2 hover:bg-custom-dark-green"
            onClick={() => {
              dispatch({ type: "WISHLIST_DRAWER", payload: false });
              // navigate to all products page
              window.location.href = "/category/all-products-LTE=";
            }}
          >
            View All Products
          </button>
        </div>
      )}
    </div>
  );
}

export default Wishlist;
